import {
    generateId,
    handleOpacity,
    handleBool,
} from '../index.js'

export default class Base {
    constructor(options) {
        const defaults = {
            id: generateId(),
            type: 'BASE',
            name: 'Base',
            visible: true,
            deleted: false,
            locked: false,
            opacity: 100,
            selected: false,
        }

        let opts = { ...defaults, ...options }

        this.id = opts.id

        this.type = opts.type
        this.name = opts.name

        this.visible = opts.visible
        this.deleted = opts.deleted
        this.locked = opts.locked
        this.opacity = opts.opacity
        this.selected = false
        this.ctx = opts.ctx
        this.buffer = opts.buffer
        this.parent = opts.parent
    }

    set(key, newValue) {
        let config = {
            visible: handleBool,
            opacity: handleOpacity,
            deleted: handleBool,
            locked: handleBool,
            selected: handleBool,
            name: (data) => { return data.newValue }
        }

        if (config[key]) {
            const oldValue = this[key]
            let parsedValue = config[key]({ newValue, oldValue })
            if (oldValue != parsedValue) {
                this[key] = parsedValue
                this.dispatch('objectStateChanged', this.propertyChangedMessage(key))
            }
        }
    }

    listenChanges() {
        if (!this.eventTarget) {
            this.eventTarget = new EventTarget();
        }
        this.on('objectStateChanged', (event) => this.onObjectStateChanged(event))
    }

    onObjectStateChanged(event) {
        // console.log("Object change detected", event.detail)
        if (this.buffer && this.renderBuffer) {
            this.renderBuffer()
        }
        if (this.parent) {
            this.dispatchToParent('objectStateChanged', this.propertyChangedMessage('Rerender'))
            //this.parent.renderBuffer()
        }
    }

    on(event, callback) {
        // console.log("Creating listener")
        this.eventListeners.push({ event, callback })
        this.eventTarget.addEventListener(event, callback)
    }

    removeListener(event, callback) {
        const toRemove = this.eventListeners.filter((e) => (event == e.event && callback == e.callback))
        if (!toRemove) return
        toRemove.forEach(listener => this.eventTarget.removeEventListener(listener.event, listener.callback))
    }

    removeAllEventListeners() {
        console.log("Removing all listeners")
        if (!this.eventTarget) return
        this.eventListeners.forEach(listener => {
            this.eventTarget.removeEventListener(listener.event, listener.callback)
        })
    }

    dispatch(event, detail) {
        if (this.eventTarget) {
            this.eventTarget.dispatchEvent(new CustomEvent(event, { detail }))
        }
    }

    dispatchToParent(event, detail) {
        if (this.parent) {
            this.parent.dispatch(event, detail)
        } else {
            console.warn("There is no parent to dispatch to")
        }
    }

    propertyChangedMessage(propertyName) {
        return {
            id: this.id,
            type: this.type,
            propertyName
        }
    }

    buffer() {
        return this.buffer
    }

    setBuffer(buffer) {
        buffer.rectMode(buffer.CENTER)
        buffer.colorMode(buffer.RGB, 255, 255, 255, 100);
        this.buffer = buffer
    }

    setSelected(isSelected) {
        this.selected = isSelected == false ? false : true
    }

    get(key) {
        return this[key]
    }

    getBaseProperties() {
        return {
            id: this.id,
            type: this.type,
            name: this.name,
            visible: this.visible,
            deleted: this.deleted,
            locked: this.locked,
            opacity: this.opacity,
            selected: false
        }
    }

    delete() {
        this.removeAllEventListeners()
        this.set('deleted', true)
    }

    toggleVisible() {
        this.visible = !this.visible
    }

    setParent(parent) {
        if (parent) {
            this.parent = parent
        }
    }

}